import { render, staticRenderFns } from "./AlertClosable.vue?vue&type=template&id=1db07950&"
import script from "./AlertClosable.vue?vue&type=script&lang=js&"
export * from "./AlertClosable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports